import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../api/api";
import { ArrowLeft, Save } from "lucide-react";

export default function AddPurchase() {
  const navigate = useNavigate();
  const { opfId } = useParams();

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    f1_po_number: "",
    f1_po_date: "",
    transfer_price: "",
    other_credits: "",
    credit_remark: "",
    f1_po_value: "",
    tax: "",
    attachment: "",
    attachment_filename: "",
    attachment_mime: "",
    delivery_details: "",
    license_key: "",
    distributor_name: "",
    distributor_invoice_no: "",
    distributor_invoice_date: "",
    distributor_invoice_value: "",
    distributor_invoice_attachment: "",
    distributor_invoice_attachment_filename: "",
    distributor_invoice_attachment_mime: "",
    other_transport_expenses: "",
  });

  const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = reject;
  });

  const updateField = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const savePurchase = async () => {
    try {
      setLoading(true);

      await api.post("/purchase/add", {
        opf_id: opfId,
        ...form,
      });

      alert("Purchase Order added successfully.");
      navigate(-1);
    } catch (err) {
      console.error(err);
      const backendMessage =
        err?.response?.data?.message || err?.message || "Unknown error";
      alert(`Failed to save purchase order: ${backendMessage}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ml-[68px] pt-16 p-6 bg-[#F4F7FB] min-h-screen">

      <div className="bg-white rounded-lg shadow border p-6">

        <div className="flex justify-between items-center mb-8">

          <div>
            <h1 className="text-2xl font-semibold">
              Add Purchase Order
            </h1>

            <p className="text-gray-500 mt-1">
              OPF ID : {opfId}
            </p>
          </div>

          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 border rounded px-4 py-2"
          >
            <ArrowLeft size={16}/>
            Back
          </button>

        </div>

        <div className="grid md:grid-cols-3 gap-5">

          <Field
            label="F1 PO Number"
            value={form.f1_po_number}
            onChange={(v)=>updateField("f1_po_number",v)}
          />

          <Field
            label="F1 PO Date"
            type="date"
            value={form.f1_po_date}
            onChange={(v)=>updateField("f1_po_date",v)}
          />

          <Field
            label="Transfer Price"
            value={form.transfer_price}
            onChange={(v)=>updateField("transfer_price",v)}
          />

          <Field
            label="Other Credits"
            value={form.other_credits}
            onChange={(v)=>updateField("other_credits",v)}
          />

          <Field
            label="Credit Remark"
            value={form.credit_remark}
            onChange={(v)=>updateField("credit_remark",v)}
          />

          <Field
            label="F1 PO Value"
            value={form.f1_po_value}
            onChange={(v)=>updateField("f1_po_value",v)}
          />

          <Field
            label="Tax"
            value={form.tax}
            onChange={(v)=>updateField("tax",v)}
          />

          <div className="flex flex-col gap-1">
  <label className="text-sm font-medium text-gray-600">
    Attachment
  </label>

  <input
    type="file"
    onChange={async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      updateField("attachment", await fileToBase64(file));
      updateField("attachment_filename", file.name);
      updateField("attachment_mime", file.type);
    }}
    className="border rounded-md px-3 py-2"
  />
</div>

          <Field
            label="Delivery Details"
            value={form.delivery_details}
            onChange={(v)=>updateField("delivery_details",v)}
          />

          <Field
            label="License Key"
            value={form.license_key}
            onChange={(v)=>updateField("license_key",v)}
          />

          <Field
            label="Distributor Name"
            value={form.distributor_name}
            onChange={(v)=>updateField("distributor_name",v)}
          />

          <Field
            label="Distributor Invoice Number"
            value={form.distributor_invoice_no}
            onChange={(v)=>updateField("distributor_invoice_no",v)}
          />

          <Field
            label="Distributor Invoice Date"
            type="date"
            value={form.distributor_invoice_date}
            onChange={(v)=>updateField("distributor_invoice_date",v)}
          />

          <Field
            label="Distributor Invoice Value"
            value={form.distributor_invoice_value}
            onChange={(v)=>updateField("distributor_invoice_value",v)}
          />

          <div className="flex flex-col gap-1">
  <label className="text-sm font-medium text-gray-600">
    Distributor Invoice Attachment
  </label>

  <input
    type="file"
    onChange={async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      updateField(
        "distributor_invoice_attachment",
        await fileToBase64(file)
      );
      updateField("distributor_invoice_attachment_filename", file.name);
      updateField("distributor_invoice_attachment_mime", file.type);
    }}
    className="border rounded-md px-3 py-2"
  />
</div>

          <Field
            label="Other Transport Expenses"
            value={form.other_transport_expenses}
            onChange={(v)=>updateField("other_transport_expenses",v)}
          />

        </div>

        <div className="mt-8 flex justify-end">

          <button
            disabled={loading}
            onClick={savePurchase}
            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md"
          >
            <Save size={18}/>
            {loading ? "Saving..." : "Save Purchase"}
          </button>

        </div>

      </div>

    </div>
  );
}

function Field({
  label,
  value,
  onChange,
  type="text"
}) {
  return (
    <div className="flex flex-col gap-1">

      <label className="text-sm font-medium text-gray-600">
        {label}
      </label>

      <input
        type={type}
        value={value}
        onChange={(e)=>onChange(e.target.value)}
        className="border rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
      />

    </div>
  );
}